export default "__VITE_ASSET__eQh07LNi__"